import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import useMediaQuery from '@mui/material/useMediaQuery';
import { collection, Query } from 'firebase/firestore';
import React, { useState } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { db } from '../../core/firebase';
import CustomerView from './customer/CustomerView';
import CustomersListView from './customers/CustomersListView';
import MessageView from './messages/MessageView';
import SubscriberProvider from './providers/SubscriberProvider';
import { ISubscriber } from './schema';

const paperStyles = {
  height: '100%',
  width: '100%',
  overflow: 'hidden'
}

export default function HouseManagerScreen() {
  const [sub, setSub] = useState<ISubscriber | null>(null);
  const desktop = useMediaQuery('(max-width:600px)');
  const [subscribers, loading] = useCollectionData<ISubscriber>(collection(db, 'scout9-sms-subscribers') as Query<ISubscriber>);

  return (
    <Grid container direction={desktop ? 'column' : 'row'} wrap="nowrap" sx={{height: 'calc(100vh - 90px)'}} spacing={2}>
      <Grid item xs={desktop ? 12 : 3}>
        <Paper
          elevation={0}
          sx={paperStyles}
          variant="outlined"
        >
          <CustomersListView
            subscribers={subscribers ? subscribers : []}
            loading={loading}
            selected={sub}
            onSelect={(s: ISubscriber | null) => {
              setSub(s);
            }}
          />
        </Paper>
      </Grid>
      <React.Fragment>
        <SubscriberProvider subscriber={sub}>
          {
            ({ subscriberProfile, subscriber, messages }) => (
              <React.Fragment>
                <Grid item xs={desktop ? 12 : 6}>
                  <Paper elevation={0} sx={paperStyles} variant="outlined">
                    {!!subscriber && !!subscriberProfile && <MessageView
                      subscriber={subscriber}
                      subscriberProfile={subscriberProfile}
                      messages={messages}
                    />}
                  </Paper>
                </Grid>
                <Grid item xs={desktop ? 12 : 3}>
                  <Paper elevation={0} sx={paperStyles} variant="outlined">
                    <CustomerView subscriber={subscriber} subscriberProfile={subscriberProfile}/>
                  </Paper>
                </Grid>
              </React.Fragment>
            )
          }
        </SubscriberProvider>

      </React.Fragment>
    </Grid>
  );
}
